export default [
    { value: '被退回', key: '0', type: 'danger' },
    { value: '待确认', key: '1', type: 'info' },
    { value: '待开票', key: '2', type: 'warning' },
    { value: '待结算', key: '3', type: 'primary' },
    { value: '已结算', key: '4', type: 'success' },
    { value: '审核中', key: '5', type: 'primary' },
];
